module.exports = __webpack_public_path__ + "static/media/galaxy.7ca6fd8f.jpg";